import React from "react";
import "../styles/DeleteModal.css"; // ✅ 별도의 스타일 파일 적용

const DeleteModal = ({ isOpen, onClose, title, message, onConfirm, confirmText }) => {
    if (!isOpen) return null;

    return (
        <div className="delete-modal-overlay">
            <div className="delete-modal-container">
                <h2 className="delete-modal-title">{title}</h2>
                <p className="delete-modal-message">{message}</p>
                <div className="delete-modal-buttons">
                    {onConfirm && <button className="delete-modal-confirm" onClick={onConfirm}>{confirmText}</button>}
                    <button className="delete-modal-close" onClick={onClose}>{onConfirm ? "취소" : "확인"}</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
